<template>
<div class="flex flex-col">

  <!-- <p class="mt-4 text-xs text-gray-400 uppercase">
    Step 1 of 6
  </p> -->

  <!-- <h1 class="flex-grow flex flex-col justify-end text-3xl text-gray-700 font-extrabold leading-snug md:text-5xl md:leading-tight">
    Find the perfect
    <br class="hidden md:inline" />
    tutor for you
  </h1> -->

  <label
    for="subject"
    class="mt-10 flex flex-col justify-end text-xl text-gray-700 font-medium sm:text-2xl"
  >
    What would you like help with?
  </label>

  <div class="mt-6 grid grid-cols-3 gap-2 w-full max-w-md sm:grid-cols-5">
    <button
      v-for="(item, idx) of popularSearches"
      class="flex flex-col justify-center items-center space-y-2.5 h-24 bg-gray-100 rounded-md border-gray-200 hover:bg-blue-100"
      :class="{ 'sm:hidden': idx >= 5 }"
      @click="subjectedSelected(item.value, item.label, item.type)"
    >
      <Heroicon
        v-if="item.icon"
        :icon="item.icon"
        class="w-8 h-8"
        :class="item.color"
      />
      <img
        v-else
        :src="item.image"
        class="h-8"
      />
      <span class="text-sm font-semibold text-gray-800">
        {{ item.label }}
      </span>
    </button>
  </div>

  <VSelect 
    v-model="search"
    :options="searchResults"
    label="Description"
    @search="onSearchInput"
    :clear-search-on-select="true"
    placeholder="Search…"
    class="find-a-tutor-search flex-1 mt-4 block w-full h-20 max-w-md rounded-md border-gray-200 text-base placeholder-gray-500 shadow-sm focus:border-blue-500 focus:ring-blue-500"
  >
    <template #no-options="{ search, searching }">
      <div class="pl-3 text-sm text-gray-600 text-left leading-relaxed">
        <template v-if="searching">
          No results found for <strong>{{ search }}</strong> but we may still be able to help.
          For now, you can  
          <button type="button" @click="skip" class="text-blue-500 font-medium hover:underline">
            skip this step
          </button>
          and detail your requirements later.
        </template>
      </div>
    </template>
    <template #option="{ Description }">
      <div class="-mx-5 px-3">
        {{ Description }}
      </div>
    </template>
  </VSelect>

  <!-- <input 
    type="search" 
    name="subject" 
    id="subject" 
    class="mt-4 block w-full max-w-md rounded-md border-gray-300 py-3 text-base placeholder-gray-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:flex-1"
    placeholder="e.g. Maths"
  /> -->

  <!-- <button type="button" class="mt-5 self-start inline-flex items-center gap-x-2.5 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
    Next
    <svg class="-mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
      <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z" fill="currentColor" />
    </svg>
  </button> -->

</div>
</template>
<script>

import vSelect from 'vue-select'
import Heroicon from '@/prototype/Heroicon.vue'
import FrenchFlagIcon from '@/assets/french-flag.png'

import SearchService from '@/services/SearchServices'

const searchService = new SearchService()


export default {
  components: {
    'VSelect': vSelect,
    Heroicon,
  },
  data() {
    return {
      search: null,
      searchResults: [],
      popularSearches: [
        { label: 'Maths', value: 'MATHS', type: 'SUBJECT', icon: 'calculator-simple-duotone', color: 'text-blue-400' },
        { label: 'English', value: 'ENGLISH', type: 'SUBJECT', icon: 'open-book-cover', color: 'text-green-400' },
        { label: '11 Plus', value: '11PLUS', type: 'LEVEL', icon: 'puzzle', color: 'text-yellow-400' },
        { label: 'Piano', value: 'PIANO', type: 'SUBJECT', icon: 'piano-duotone', color: 'text-purple-600' },
        { label: 'French', value: 'FRENCH', type: 'SUBJECT', image: FrenchFlagIcon },
        { label: 'Biology', value: 'BIOLOGY', type: 'SUBJECT', icon: 'bacterium', color: 'text-pink-400' },
      ]
    }
  },
  methods: {
    async onSearchInput(searchStr, loadingCallback) {
      loadingCallback(true)
      var response = await searchService.initialSearch(searchStr.trim())
      loadingCallback(false)

      this.searchResults = response.data.results[0]?.Levels || []
      this.searchResults = this.searchResults.slice(0, 5)
      this.searchResults.sort((a, b) => (a.SortOrder ?? 9999) > (b.SortOrder ?? 9999) ? 1 : -1)
    },
    subjectedSelected(id, name, type) {
      if (type === 'SUBJECT') {
        this.$emit('updateEnquiry', { subjectId: id, initialName: name, levelId: null, })
        this.$router.push({ name: 'FindATutor-Level' })
      }
      else {
        this.$emit('updateEnquiry', { subjectId: null, initialName: name, levelId: id, })
        this.$router.push({ name: 'FindATutor-Subject' })
      }
    },
    skip() {
      this.$emit('updateEnquiry', { subjectId: null, initialName: null, levelId: null, })
      this.$router.push({ name: 'FindATutor-Location' })
    }
  },
  watch: {
    search(newVal) {
      this.subjectedSelected(newVal.Id, newVal.Description, newVal.Type)
    }
  }
}
</script>
<style lang="scss">

.find-a-tutor-search {

  .noDrop .vs__dropdown-menu
  {
    display: none !important;
  }

  .vs__dropdown-menu
  {
    margin-top: -10px;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  }

  .vs__dropdown-toggle {
    padding: 0;
    background-color: #fff;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
    border-radius: 0.375rem !important;
  }

  .vs__search, .vs__search:focus, .vs__selected {
    margin: 0;
    padding: 8px 12px;
    line-height: 2;
  }

  .vs__selected-options {
    padding: 0;
  }

  .vs__search::placeholder {
    color: #6b7280;
  }

  .vs__open-indicator {
    display: none;
  }

  .vs__actions {
    padding: 0 12px;
  }
  
  .vs--disabled .vs__search {
    background: transparent;
  }

}

</style>